export default "/static/dashboard/build/app/img/v2/0d7eec9fba4e5731a483a3c9a437ad21.png";